@if (isLoadingResults) {
  <ng-container [dynamicWidget]="input.loadingWidget" [context]="context" />
}

@if (isLoadingResults !== true) {
  @if (
    mergeContexts(
      context,
      wrapContext(
        filteredData | async,
        input?.filteredDataAlias || 'filteredData'
      )
    );
    as mergedContext
  ) {
    <ng-container [dynamicWidget]="input.widget" [context]="mergedContext" />
  }
}

<div
  class="paginator-container"
  [style.paddingLeft]="paddingLeft"
  [style.paddingRight]="paddingRight"
  [style.paddingTop]="paddingTop"
  [style.paddingBottom]="paddingBottom"
  [style.marginTop]="marginTop"
  [style.marginLeft]="marginLeft"
  [style.marginRight]="marginRight"
  [style.marginBottom]="marginBottom"
>
  @if (loadingStateCounter.isLoading$ | async) {
    <mat-spinner diameter="24"></mat-spinner>
  }
  <mat-paginator
    [length]="length"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons="true"
    (page)="bindPaginator($event)"
  ></mat-paginator>
</div>
